module.exports = __webpack_public_path__ + "img/rice field 2-01.95c343ae.png";